import { createQueryKeys } from "./create-query-keys";
import { getCommercialProducts, getResearchProducts, } from "../api/generated/wrappers/product";
const productQueryKeys = createQueryKeys("product", {
    all: (isCommercial, params) => ({
        queryKey: ["all", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialProducts(params)
            : await getResearchProducts(params),
    }),
});
export default productQueryKeys;
